import {SUPPORTS_SYMBOL} from "./constructor";

export const SUPPORTS_SYMBOL_MATCH = SUPPORTS_SYMBOL && "match" in Symbol;
